import React from "react";
import { MessageCircle } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const WhatsAppSettingsFields = ({ form, onChange }) => <section className="border-b border-black/10 pb-7 mb-7">
  <h3 className="font-display font-semibold text-lg mb-5">Customer support</h3>
  <Label htmlFor="admin-settings-whatsapp" className="flex items-center gap-2 text-sm"><MessageCircle className="w-4 h-4 text-orange-600 shrink-0" />One WhatsApp number for the entire website</Label>
  <Input id="admin-settings-whatsapp" data-testid="admin-settings-whatsapp" value={form.whatsapp || ""} type="tel" maxLength={40} placeholder="International number including country code" onChange={onChange("whatsapp")} className="mt-2 bg-white" />
  <p data-testid="support-number-scope" className="text-xs text-neutral-500 mt-2">Send Parcel · Inquiries · Track Package · WhatsApp Us</p>
</section>;